import React, { useEffect } from 'react';
import { setObjProp } from '../../utils';
import { SelectInputWrapper } from 'react-lib/dist/components-es';
import { withTranslation } from 'react-i18next';

const CommonSelectInputWrapper = ({ i18n, t, ...props }) => {
  const idx = props.name.lastIndexOf('.');
  const calculatedPropUsedInChanges =
    props.name.substring(0, idx + 1).trim() + props.propUsedInChanges;

  useEffect(() => {
    const { options, values, value } = props;
    if (i18n.language && value && options.length > 0) {
      let selectedOption = options.find(o => o.value == value);
      setObjProp(values, calculatedPropUsedInChanges, t(selectedOption?.text));
    }
  }, [i18n.language, props.options.map(o => o.text)]);

  const onChangeBeforeStateUpdate = (e, value) => {
    setObjProp(props.values, calculatedPropUsedInChanges, e.target.innerText);
  };

  return <SelectInputWrapper {...props} onChangeBeforeStateUpdate={onChangeBeforeStateUpdate} />;
};

CommonSelectInputWrapper.defaultProps = {
  propUsedInChanges: 'value',
};

export default withTranslation()(CommonSelectInputWrapper);
